module.exports = __webpack_public_path__ + "media/images/icons/icon-gem-6bd88f558e23cf6245cb1fa2b462c3d6.svg";